import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from '../../../services-http/auth/auth.service';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { NotificationService } from '../../../services-http/notification/notification.service'
import Swal from 'sweetalert2'


@Component({
  selector: 'app-user-management-officer',
  templateUrl: './user-management-officer.component.html',
  styleUrls: ['./user-management-officer.component.scss']
})
export class UserManagementOfficerComponent implements OnInit {
  @ViewChild('frame') frame: ModalDirective;

  user:any = JSON.parse(localStorage.getItem('currentUser'));
  userType:any;
  coopName:any;
  notifList:any = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    public notification:NotificationService
  ) {
    this.notification.connect(this.user);
     // register ang user bai using userid
            this.notification.ws.onopen = () => {
              console.log('Connected to server');
        
              const payload = {
                type: "register",
                user_id: this.user.iloginId
              };
              this.notification.ws.send(JSON.stringify(payload));
            };
          
            
            this.notification.ws.onmessage = (event) => {
              
              this.notifList.unshift(JSON.parse(event.data));
              this.notification.playSound();
            };
          
            this.notification.ws.onclose = () => {
              // Swal.fire(
              //   'Error',
              //   'Connection closed, realtime notification is not available.',
              //   'error'
              // );
              console.log('Connection closed, realtime notification is not available.');

            };
          
        
            this.notification.ws.onerror = (error) => {
              // Swal.fire(
              //   'Error',
              //   'WebSocket error' + error,
              //   'error'
              // );
                console.log('WebSocket error' + error);
            };
   }


  ngOnInit() {

    this.getnotif();
  }


  logout() {
    this.authService.logout();
  }
  
   
  gotoProfileView() {
    this.router.navigateByUrl('/user-management-officer/cac-profile/' + this.user['userId'] + '/view');
  }



  notificationRead(notification){
    this.notification.notificationRead(notification)
    .subscribe(res =>{
   
    });
  }

  getnotif(){
    this.notification.getNotification(this.user.iloginId).subscribe(res => {
      this.notifList = res;
   })
  }


  get unreadNotifCount(): number  {
    return this.notifList.filter(x => x.status == 1).length;
  }

}
